/**
 * Component: Product Tabs
 * ------------------------------------------------------------------------------
 *
 * @namespace deliveryDates
 */

import log from 'salvo-lite/log'

class ProductTabs {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            scrollTo: '[data-product-tabs-scroll]',
            control: '[data-product-tabs-control]',
            ...JSON.parse(elem.getAttribute('data-delivery-dates') || '{}')
        }

        this._nodeSelectors = {
            scrollTo: document.querySelectorAll(this._settings.scrollTo),
            control: this._elem.querySelectorAll(this._settings.control)
        }

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._setListeners()
    }

    _setListeners () {
        this._nodeSelectors.control.forEach((el) => {
            el.addEventListener('click', (event) => {
                const id = event.target.getAttribute('data-product-tabs-control')
                this._toggleTab(id)
            })
        })

        this._nodeSelectors.scrollTo.forEach((el) => el.addEventListener('click', (event) => this._scrollToTab(event.target)))
    }

    _toggleTab (id) {
        this._elem.querySelector('.active[data-product-tabs-control]').classList.remove('active')
        this._elem.querySelector('.active[data-product-tabs-content]').classList.remove('active')

        this._elem.querySelector(`[data-product-tabs-control=${id}]`).classList.add('active')
        this._elem.querySelector(`[data-product-tabs-content=${id}]`).classList.add('active')
    }

    _scrollToTab (element) {
        let position = document.querySelector('#product-tabs__nav').getBoundingClientRect().top

        if (window.innerWidth <= 768) {
            position = document.querySelector('.product-details__compatibility').getBoundingClientRect().top
        }

        window.scrollBy({
            top: position - 240,
            behavior: 'smooth'
        })

        const attr = element.closest('[data-product-tabs-scroll]').getAttribute('data-product-tabs-scroll')
        this._toggleTab(attr)
    }

    // /**
    //  * Expose public interface.
    //  */
    // return Object.freeze({
    //   init,
    // })
}

export default ProductTabs



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductTabs.js